import { Loader2 } from 'lucide-react'

export const FullScreenLoader = () => {
  return (
    <div className="flex items-center flex-1 justify-center bg-background/40 ">
      <Loader2 className="w-10 h-10 animate-spin text-muted-foreground" />
    </div>
  )
}
